import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Col, ListGroup, Row } from "react-bootstrap";
import { useLanguage } from "hooks";
import { logout } from "store/auth";
import { Avatar, Icons } from "components";

export default function Nav() {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth); // call data from auth store
  const handleLogout = () => dispatch(logout());

  return (
    <div className="profile_nav bg-white rounded py-4">
      <Row className="align-items-center px-0 mx-0">
        <Col xl={4} lg={4} md={4} sm={4} xs={4}>
          <Avatar image={user.image} />
        </Col>
        <Col xl={8} lg={8} md={8} sm={8} xs={8}>
          <Row>
            <Col xs={12}>{user.name}</Col>
            <Col xs={12}>
              <small>
                {user.school?.name} {user.class?.name}
              </small>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="mt-4 px-0 mx-0">
        <ListGroup variant="flush" className="px-0 mx-0">
          {/* "react-bootstrap" component that display a list in specified style*/}
          <ListGroup.Item className="px-4">
            {/* List Group Item profile line */}
            <NavLink end activeclassname="active" to="/profile/">
              <Row className="align-items-center">
                <Col
                  xl={2}
                  lg={2}
                  md={2}
                  sm={2}
                  xs={2}
                  className="text-center px-3"
                >
                  <Icons.UserCircle width="24" />
                </Col>
                <Col xl={10} lg={10} md={10} sm={10} xs={10}>
                  <p className="fw-normal">{language.profile}</p>
                </Col>
              </Row>
            </NavLink>
          </ListGroup.Item>
          <ListGroup.Item className="px-4">
            {/* List Group Item history line */}
            <NavLink activeclassname="active" to="/profile/history">
              <Row className="align-items-center">
                <Col
                  xl={2}
                  lg={2}
                  md={2}
                  sm={2}
                  xs={2}
                  className="text-center px-3"
                >
                  <Icons.History width="24" />
                </Col>
                <Col xl={10} lg={10} md={10} sm={10} xs={10}>
                  <p className="fw-normal">{language.history}</p>
                </Col>
              </Row>
            </NavLink>
          </ListGroup.Item>
          <ListGroup.Item className="px-4">
            {/* List Group Item favourite line */}
            <NavLink activeclassname="active" to="/profile/favourite">
              <Row className="align-items-center">
                <Col
                  xl={2}
                  lg={2}
                  md={2}
                  sm={2}
                  xs={2}
                  className="text-center px-3"
                >
                  <Icons.Favourite width="24" />
                </Col>
                <Col xl={10} lg={10} md={10} sm={10} xs={10}>
                  <p className="fw-normal">{language.favourite}</p>
                </Col>
              </Row>
            </NavLink>
          </ListGroup.Item>
          <ListGroup.Item className="px-4">
            {/* List Group Item logout button */}
            <button
              onClick={handleLogout}
              className="border-0 bg-transparent d-block w-100"
            >
              <Row className="align-items-center">
                <Col
                  xl={2}
                  lg={2}
                  md={2}
                  sm={2}
                  xs={2}
                  className="text-center px-3"
                >
                  <Icons.Logout width="24" />
                </Col>
                <Col xl={10} lg={10} md={10} sm={10} xs={10}>
                  <p className="fw-normal text-start">{language.logout}</p>
                </Col>
              </Row>
            </button>
          </ListGroup.Item>
        </ListGroup>
      </Row>
    </div>
  );
}
